var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderindexDocumentLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 25,
    viewBox: "0 0 20.5 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9703",
    "data-name": "Grupo 9703",
    transform: "translate(-508.498 -229.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9702",
    "data-name": "Grupo 9702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11211",
    "data-name": "Grupo 11211"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2745",
    "data-name": "Ret\\xE2ngulo 2745",
    width: 19.5,
    height: 24,
    rx: 1,
    transform: "translate(508.998 230.26)",
    fill: "none",
    stroke: "#415364",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9701",
    "data-name": "Grupo 9701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11788",
    "data-name": "Caminho 11788",
    d: "M525.593,235.95H511.9a.417.417,0,1,0,0,.834h13.69a.417.417,0,0,0,0-.834Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11789",
    "data-name": "Caminho 11789",
    d: "M525.593,238.307H511.9a.417.417,0,1,0,0,.834h13.69a.417.417,0,0,0,0-.834Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11790",
    "data-name": "Caminho 11790",
    d: "M525.593,240.665H511.9a.417.417,0,1,0,0,.833h13.69a.417.417,0,1,0,0-.833Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11791",
    "data-name": "Caminho 11791",
    d: "M525.593,243.022H511.9a.416.416,0,1,0,0,.833h13.69a.416.416,0,1,0,0-.833Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11792",
    "data-name": "Caminho 11792",
    d: "M525.593,245.379H511.9a.417.417,0,1,0,0,.833h13.69a.417.417,0,1,0,0-.833Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11793",
    "data-name": "Caminho 11793",
    d: "M522.978,247.736h-8.459c-.143,0-.258.186-.258.417s.115.416.258.416h8.459c.142,0,.257-.186.257-.416S523.12,247.736,522.978,247.736Z",
    fill: "#415364"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderindexDocumentLarge);
export default __webpack_public_path__ + "static/media/folderindex-document-large.e14443918eeb7e706c40b9c54d475c09.svg";
export { ForwardRef as ReactComponent };